import { render, staticRenderFns } from "./Verify.vue?vue&type=template&id=a61279ca"
import script from "./Verify.vue?vue&type=script&lang=js"
export * from "./Verify.vue?vue&type=script&lang=js"
import style0 from "./Verify.vue?vue&type=style&index=0&id=a61279ca&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\java\\project\\kaixinshequ-java\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a61279ca')) {
      api.createRecord('a61279ca', component.options)
    } else {
      api.reload('a61279ca', component.options)
    }
    module.hot.accept("./Verify.vue?vue&type=template&id=a61279ca", function () {
      api.rerender('a61279ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/verifition/Verify.vue"
export default component.exports